var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIcon01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4832 9.08073V3.41406C18.4832 2.16406 17.9499 1.66406 16.6249 1.66406H13.2582C11.9332 1.66406 11.3999 2.16406 11.3999 3.41406V9.08073C11.3999 10.3307 11.9332 10.8307 13.2582 10.8307H16.6249C17.9499 10.8307 18.4832 10.3307 18.4832 9.08073Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73324 10.9141V16.5807C9.73324 17.8307 9.1999 18.3307 7.8749 18.3307H4.50824C3.18324 18.3307 2.6499 17.8307 2.6499 16.5807V10.9141C2.6499 9.66406 3.18324 9.16406 4.50824 9.16406H7.8749C9.1999 9.16406 9.73324 9.66406 9.73324 10.9141Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.4832 16.5833V14.25C18.4832 13 17.9499 12.5 16.6249 12.5H13.2582C11.9332 12.5 11.3999 13 11.3999 14.25V16.5833C11.3999 17.8333 11.9332 18.3333 13.2582 18.3333H16.6249C17.9499 18.3333 18.4832 17.8333 18.4832 16.5833Z",
    fill: "#333548",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.73324 5.7474V3.41406C9.73324 2.16406 9.1999 1.66406 7.8749 1.66406H4.50824C3.18324 1.66406 2.6499 2.16406 2.6499 3.41406V5.7474C2.6499 6.9974 3.18324 7.4974 4.50824 7.4974H7.8749C9.1999 7.4974 9.73324 6.9974 9.73324 5.7474Z",
    fill: "#333548",
    fillOpacity: 0.75
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon01);
export default __webpack_public_path__ + "static/media/menu-icon-01.81f5735568ebb33840ed9e16c3a0ef8e.svg";
export { ForwardRef as ReactComponent };